import React from 'react';
import LoginComponent from '../component/Login';

const Login = () => {
    return (
        <div>
            <LoginComponent/>
        </div>
    );
}

export default Login;  